
import { Component, Vue, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import {
  getCategoryStatistics,
  getCategoryStatisticsShop,
} from "@/api/shouyin";
import { getYoytTime } from "../../workbench/components/CategoryProportion.vue";
import DimensionSelect from "@/components/DimensionSelect/index.vue";
import SearchPopup from "./SearchPopup.vue";
import CategoryProportionTable from "./CategoryProportionTable.vue";

// 类别占比详情
@Component({
  components: { DimensionSelect, SearchPopup, CategoryProportionTable },
})
export class CategoryProportionDetail extends Vue {
  @Getter isMultiStore!: boolean;
  @Getter companyId!: string;
  @Getter multiStoreList!: Array<any>;

  params = {};

  dimensionName = "门店";
  dimensionValue = "1";
  showTotal = false;
  searchRes = null;
  timeData: any = {};

  columnsTree = [
    {
      key: "categoryName",
      title: "类别名称",
      width: 80,
      textOverflow: "ellipsis",
    },
    {
      key: "percentage",
      title: "占比",
      align: "left",
      dataType: "proportion",
      width: 100,
    },
    {
      key: "yoyPercentage",
      title: "环比",
      align: "right",
      textOverflow: "auto",
    },
    {
      key: "orderMoney",
      title: "销售金额",
      align: "right",
      dataType: "amount",
      textOverflow: "auto",
    },
  ];
  tableDataSourceTree = [
    // {
    //   categoryName: "类别1",
    //   percentage: 0.5,
    //   yoyPercentage: "+14%",
    //   ratioStyle: this.getStyle(1),
    //   orderMoney: 310,
    //   open: false,
    //   childrens: [
    //     {
    //       categoryName: "子类1",
    //       percentage: 0.2,
    //       yoyPercentage: "+20%",
    //       ratioStyle: this.getStyle(1),
    //       orderMoney: 120,
    //     },
    //     {
    //       categoryName: "子类2",
    //       percentage: 0.2,
    //       yoyPercentage: "+20%",
    //       ratioStyle: this.getStyle(1),
    //       orderMoney: 140,
    //     },
    //     {
    //       categoryName: "子类3",
    //       percentage: 0.1,
    //       yoyPercentage: "-10%",
    //       ratioStyle: this.getStyle(1),
    //       orderMoney: 50,
    //     },
    //   ],
    // },
    // {
    //   categoryName: "类别2",
    //   percentage: 0.15,
    //   yoyPercentage: "+12%",
    //   ratioStyle: this.getStyle(1),
    //   orderMoney: 1400,
    // },
    // {
    //   categoryName: "类别3",
    //   percentage: 0.1,
    //   yoyPercentage: "+2%",
    //   ratioStyle: this.getStyle(1),
    //   orderMoney: 985,
    // },
    // {
    //   categoryName: "类别类别类别",
    //   percentage: 0.25,
    //   yoyPercentage: "-6%",
    //   ratioStyle: this.getStyle(1),
    //   orderMoney: 210,
    // },
  ];

  @Watch("params")
  onParamsChange() {
    this.getData();
  }

  async getData() {
    const [prevQueryTimeBegin, prevQueryTimeEnd, queryType] = getYoytTime(
      this.params
    );
    const param: any = {
      ...this.params,
      queryType: this.dimensionValue,
      categoryLevel: 1,
      prevQueryTimeBegin,
      prevQueryTimeEnd,
    };
    let res: any;
    if (this.isMultiStore) {
      param.storeList = this.multiStoreList.map((item) => {
        return { storeId: item };
      });
      res = await getCategoryStatisticsShop(param, true);
    } else {
      res = await getCategoryStatistics(param, true);
    }

    res.data.forEach((item) => {
      const iszero = !item.yoyOrderMoney || item.yoyOrderMoney === 0;
      item.yoyPercentageStyle = this.getStyle(!iszero ? item.yoyPercentage : 0);
      item.yoyPercentage = iszero ? "--" : item.yoyPercentage + "%";
      item.childrens = [];
      item.open = false;
    });
    this.tableDataSourceTree = res.data || [];
  }

  onDimensionConfirm(name: string, value: string) {
    this.dimensionName = name;
    this.dimensionValue = value;
    this.getData();
  }

  onSearchConfirm(res) {
    this.searchRes = res;
    this.timeData = res;
    const { starttime, endtime } = res;
    this.params = {
      queryTimeBegin: `${starttime} 00:00:00`,
      queryTimeEnd: `${endtime} 23:59:59`,
      queryType: this.dimensionValue,
      storeId: this.companyId,
      timeType: res.value,
    };
  }

  getStyle(num = 1) {
    if (num > 0) {
      return {
        color: "#FD8305",
      };
    }
    return {};
  }

  async onExpand(record: any) {
    const index = this.tableDataSourceTree.findIndex(
      (item: any) => item.categoryId === record.categoryId
    );
    if (record.open) {
      if (this.tableDataSourceTree[index].childrens.length) return;
      const [prevQueryTimeBegin, prevQueryTimeEnd] = getYoytTime(this.params);
      const param: any = {
        ...this.params,
        queryType: this.dimensionValue,
        categoryId: record.categoryId,
        categoryLevel: record.categoryLevel,
        prevQueryTimeBegin,
        prevQueryTimeEnd,
      };
      let res: any;
      if (this.isMultiStore) {
        param.storeList = this.multiStoreList.map((item) => {
          return { storeId: item };
        });
        res = await getCategoryStatisticsShop(param, true);
      } else {
        res = await getCategoryStatistics(param, true);
      }

      console.log("二级 查询类别占比 ***", res);
      if (index !== -1) {
        res.data.forEach((item) => {
          const iszero = !item.yoyOrderMoney || item.yoyOrderMoney === 0;
          item.yoyPercentageStyle = this.getStyle(
            !iszero ? item.yoyPercentage : 0
          );
          item.yoyPercentage = iszero ? "--" : item.yoyPercentage + "%";
        });
        this.tableDataSourceTree[index].childrens = res.data || [];
      }
    }
  }

  gotoReport(row: any) {
    const { categoryId, categoryName, storeName = "", storeId = "" } = row;

    const obj = {
      searchRes: this.timeData,
      dimension: {
        text: this.dimensionName,
        orderType: this.dimensionValue,
      },
      category: {
        categoryId,
        categoryName,
      },
      storeObj: {
        storeName,
        storeId,
      },
    };
    window.localStorage.setItem("CategoryParams", JSON.stringify(obj));
    const query = this.$route.query;
    this.$router.push({
      path: "/goodsRankingDetail",
      query: {
        ...query,
        isCategory: "1",
      },
    });
  }
  mounted() {
    const { isWorkbench } = this.$route.query;
    const isGoodsRankingGoback = window.localStorage.getItem(
      "isGoodsRankingGoback"
    );
    if (isWorkbench !== "1" && isGoodsRankingGoback !== "1") {
      return;
    }

    let paramsStr = "";
    // 工作台过来
    if (isWorkbench === "1") {
      paramsStr = window.localStorage.getItem("WorkbenchParams");
    }
    // 商品排行过来
    if (isGoodsRankingGoback === "1") {
      paramsStr = window.localStorage.getItem("CategoryParams");
      window.localStorage.setItem("isGoodsRankingGoback", "0");
    }

    const pObj: any = { ...this.params };
    console.log("pObj mounted ***", pObj);

    if (paramsStr && paramsStr !== "") {
      const workbenchParams = JSON.parse(paramsStr);

      if (workbenchParams.searchRes) {
        const searchRes = workbenchParams.searchRes;

        pObj.queryTimeEnd = `${searchRes.endtime} 23:59:59`;
        pObj.queryTimeBegin = `${searchRes.starttime} 00:00:00`;
        this.searchRes = searchRes;
        this.timeData = searchRes;
      }
      if (workbenchParams.dimension) {
        pObj.queryType = workbenchParams.dimension.orderType;
        this.dimensionName = workbenchParams.dimension.text;
        this.dimensionValue = pObj.queryType;
      }
    }
    this.params = pObj;
  }
}
export default CategoryProportionDetail;
